export interface UsefulInfo {
  title: string;
  description: string;
}
